import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = {
  errors: [],
  verify: {},
}

export const recaptcha = createSlice({
  name: 'recaptcha',
  initialState,
  reducers: {
    addError: (state, action) => {
      state.errors.push({
        id: action.payload.type,
        ...action.payload,
      })
    },
    removeError: (state, action: PayloadAction<string>) => {
      const errorIndex = state.errors.findIndex((r) => r.id === action.payload)
      state.errors.splice(errorIndex, 1)
    },
  },
})

export const selectSelf = (state) => state.recaptcha
export const selectRecaptchaErrors = createSelector(
  selectSelf,
  (recaptcha) => recaptcha.errors
)
export const selectRecaptchaVerify = createSelector(
  selectSelf,
  (recaptcha) => recaptcha.verify
)

export const { addError, removeError } = recaptcha.actions

export default recaptcha.reducer
